<div class="row" [class.in-categorie]="inCategorie()" [class.first]="first()">
	<div class="row-select">
		<app-checkbox [(value)]="selected"></app-checkbox>
	</div>
	<div class="row-info">
		<div class="row-primary" (click)="selected.set(!selected())">{{ primary() }}</div>
		<div class="row-secondary">{{ secondary() }}</div>
	</div>
	@if (showEditDelete()) {
		<div class="row-icons">
			<app-icon name="edit" color="typography-3" size="small" (click)="editClicked.emit(true)"></app-icon>
			<app-icon name="delete" color="typography-3" size="small" (click)="deleteClicked.emit(true)"></app-icon>
		</div>
	}
</div>
